/**
 * A single shared audio-focus point (spec 046 FR-018: "Audio MUST never overlap — new
 * speech stops prior speech"). Every place that plays narration/TTS registers a stop
 * callback here before playing; starting new audio anywhere calls the previous stopper
 * first, so at most one thing is ever speaking.
 */
let currentStopper: (() => void) | null = null;

export function claimAudioFocus(stopper: () => void): void {
  if (currentStopper && currentStopper !== stopper) {
    currentStopper();
  }
  currentStopper = stopper;
}

export function releaseAudioFocus(stopper: () => void): void {
  if (currentStopper === stopper) {
    currentStopper = null;
  }
}

export function stopAllAudio(): void {
  if (currentStopper) {
    currentStopper();
    currentStopper = null;
  }
}
